module.exports = __webpack_public_path__ + "img/teacher_view_student_virtual_button.beb3132e.jpg";